import { useEffect } from "react";
import { useAppDispatch } from "app/store";
import { useGetListMemberQuery } from "features/ui-content/endpoints";
import {
  teamMemberLoaded,
  litigationTeamMemberLoaded,
  noticeTeamMemberLoaded,
} from "features/ui-content/slice";
import { GaiaConstants } from "utils";

/**
 * Hook to load team members when current resource team changes
 * @param currentResourceTeam The current resource team name
 */
export const useTeamMembersLoader = (currentResourceTeam: string) => {
  const dispatch = useAppDispatch();

  // Fetch team members for the current resource team
  const { data: teamMembersData, isLoading: isLoadingTeamMembers } =
    useGetListMemberQuery(
      { teamName: currentResourceTeam || "" },
      {
        refetchOnMountOrArgChange: true,
        skip:
          !currentResourceTeam ||
          currentResourceTeam === GaiaConstants.PLACE_HOLDER,
      },
    );

  // Dispatch data to store when received
  useEffect(() => {
    if (teamMembersData) {
      dispatch(teamMemberLoaded(teamMembersData));
      dispatch(litigationTeamMemberLoaded(teamMembersData));
      dispatch(noticeTeamMemberLoaded(teamMembersData));
    }
  }, [dispatch, teamMembersData, currentResourceTeam]);

  return {
    isLoadingTeamMembers,
  };
};
